import apiClient from './client.js';

export const fetchContracts = async (params = {}) => {
  const { data } = await apiClient.get('/contracts', { params });
  return data;
};

export const fetchContract = async (id) => {
  const { data } = await apiClient.get(`/contracts/${id}`);
  return data;
};

export const createContract = async (payload) => {
  const { data } = await apiClient.post('/contracts', payload);
  return data;
};

export const sendForSignature = async (id) => {
  const { data } = await apiClient.post(`/contracts/${id}/send`);
  return data;
};
// Backward compat alias
export const sendToDocusign = sendForSignature;

export const fetchAmbassadorData = async (contractId) => {
  const { data } = await apiClient.get(`/contracts/${contractId}`);
  return data;
};

export const downloadContractDocx = async (id) => {
  const { data } = await apiClient.get(`/contracts/${id}/docx`, {
    responseType: 'blob',
  });
  return data;
};

export const downloadSignedZip = async (id) => {
  const { data } = await apiClient.get(`/contracts/${id}/signed-zip`, {
    responseType: 'blob',
  });
  return data;
};

export const downloadSignedPdf = async (id) => {
  const { data } = await apiClient.get(`/contracts/${id}/signed-pdf`, {
    responseType: 'blob',
  });
  return data;
};

// Phase 56-02: Content-Disposition-aware variants. Browsers ignore server-supplied
// filename when <a download="..."> attribute is set, so the frontend must parse
// the header itself and pass the server-authoritative filename into a.download.
export function filenameFromContentDisposition(header) {
  if (!header) return null;
  // RFC 5987 form: filename*=UTF-8''... (preferred when present)
  const m1 = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (m1) {
    try { return decodeURIComponent(m1[1]); } catch { return m1[1]; }
  }
  // Quoted form: filename="..."
  const m2 = header.match(/filename="([^"]+)"/i);
  if (m2) return m2[1];
  // Unquoted form: filename=foo.pdf
  const m3 = header.match(/filename=([^;]+)/i);
  if (m3) return m3[1].trim();
  return null;
}

// Triggers a browser download using the filename advertised by the server
// (with a local fallback when the header is absent or unreadable).
export function triggerDownloadFromResponse(blob, serverFilename, fallback) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = serverFilename || fallback;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export const downloadSignedZipWithName = async (id) => {
  const resp = await apiClient.get(`/contracts/${id}/signed-zip`, { responseType: 'blob' });
  const filename = filenameFromContentDisposition(resp.headers['content-disposition']);
  return { blob: resp.data, filename };
};

export const downloadSignedPdfWithName = async (id) => {
  const resp = await apiClient.get(`/contracts/${id}/signed-pdf`, { responseType: 'blob' });
  const filename = filenameFromContentDisposition(resp.headers['content-disposition']);
  return { blob: resp.data, filename };
};

export const updateAmbassadorData = async (id, payload) => {
  const { data } = await apiClient.patch(`/contracts/${id}/ambassador-data`, payload);
  return data;
};

// Phase 57-01: «Ссылка отправлена» button — transitions draft → link_sent
export const markLinkSent = async (id) => {
  const { data } = await apiClient.patch(`/contracts/${id}/status`, { status: 'link_sent' });
  return data;
};

export const deleteContract = async (id) => {
  const { data } = await apiClient.delete(`/contracts/${id}`);
  return data;
};

export const updateContractStatus = async (contractId, status) => {
  const { data } = await apiClient.patch(`/contracts/${contractId}/status`, { status });
  return data;
};

// P-E3: «Постинг через VPN (США)». Dedicated route, not a general contract PATCH (D4).
export const setContractVpn = async (id, postingViaVpn) => {
  const { data } = await apiClient.patch(`/contracts/${id}/vpn`, { postingViaVpn });
  return data;
};
